import { render, staticRenderFns } from "./AssessmentTestModal.vue?vue&type=template&id=778402a0"
import script from "./AssessmentTestModal.vue?vue&type=script&lang=js"
export * from "./AssessmentTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports